import { render, staticRenderFns } from "./Abilities.vue?vue&type=template&id=272e0eb3&scoped=true&"
import script from "./Abilities.vue?vue&type=script&lang=js&"
export * from "./Abilities.vue?vue&type=script&lang=js&"
import style0 from "./Abilities.vue?vue&type=style&index=0&id=272e0eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272e0eb3",
  null
  
)

export default component.exports